import React from 'react';
import ReactDOM from 'react-dom';
import ScheduledPerformanceSummaryReact from './ScheduledPerformanceSummary';

class ScheduledPerformanceSummary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = '<div id="root"></div>';

    ReactDOM.render(
      React.createElement(ScheduledPerformanceSummaryReact, {
        reportData: JSON.parse(this.getAttribute('report_data')),
        locationNames: JSON.parse(this.getAttribute('location_names')),
        groupNames: JSON.parse(this.getAttribute('group_names')),
        endDate: this.getAttribute('end_date'),
      }),
      this.querySelector('#root')
    );
  }
}

customElements.define('scheduled-performance-summary', ScheduledPerformanceSummary);
